<template>
  <div class="bg-white rounded box-shadow p-1">
    <b-modal id="business-modal" size="lg" title="Affected Business Information" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="structure_id">Structure Affected <span class="c-required">*</span></label>
            <select v-model="business.structure_id" v-validate="'required'" id="structure_id" name="structure_id" class="form-control form-control-sm">
              <option selected :value="''">Select Structure</option>
              <option v-for="(structure, index) in structures" v-bind:value="structure.id" :key="index">Structure Use Code : {{ structure.structure_use_code.structure_use_code_desc }}, Structure Des Code: {{ structure.structure_des_code.structure_des_code_desc }}</option>
            </select>
            <div class="invalid-feedback">Please select valid structure</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="business_name">Name of Business</label>
            <input type="text" v-model="business.business_name" id="business_name" name="business_name" class="form-control form-control-sm" placeholder="Business name"/>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="business_op_name">Business Operator Name <span class="c-required">*</span></label>
            <input type="text" v-model="business.business_op_name" v-validate="'required'" id="business_op_name" name="business_op_name" class="form-control form-control-sm" placeholder="Business operation"/>
            <div class="invalid-feedback">Please enter business operator name</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="type_business">Type of Business <span class="c-required">*</span></label>
            <input type="text" v-model="business.type_business" v-validate="'required'" id="type_business" name="type_business" class="form-control form-control-sm" placeholder="Enter type of business"/>
            <div class="invalid-feedback">Please enter type of business</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="business_capital">Capital <span class="c-required">*</span></label>
            <input type="number" v-model="business.business_capital" v-validate="'required|numeric'" id="business_capital" name="business_capital" class="form-control form-control-sm" placeholder="Enter business capital"/>
            <div class="invalid-feedback">Please enter business capital and number format</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="fathers_name">Father's Name <span class="c-required">*</span></label>
            <input type="text" v-model="business.fathers_name" v-validate="'required'"  id="fathers_name" name="fathers_name" class="form-control form-control-sm" placeholder="Fathers name"/>
            <div class="invalid-feedback">Please enter father`s name</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <label for="address">Present Address <span class="c-required">*</span></label>
            <textarea v-model="business.address" v-validate="'required'" id="address" name="address" class="form-control form-control-sm" placeholder="Enter Address"></textarea>
            <div class="invalid-feedback">Please enter present address</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="yearly_income">Yearly Income <span class="c-required">*</span></label>
            <input type="number" v-model="business.yearly_income" v-validate="'required|numeric'" id="yearly_income" name="yearly_income" class="form-control form-control-sm" placeholder="Enter yearly income"/>
            <div class="invalid-feedback">Please enter yearly income and number format</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="employees"># of Employees <span class="c-required">*</span></label>
            <input type="number" v-model="business.employees"  v-validate="'required|numeric'"  id="employees" name="employees" class="form-control form-control-sm" placeholder="Enter number of employee"/>
            <div class="invalid-feedback">Please enter no of employees and number format</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="trade_licensing_no">Trade Licensing no.</label>
            <input type="text" v-model="business.trade_licensing_no" id="trade_licensing_no" name="trade_licensing_no" class="form-control form-control-sm" placeholder="Enter trade licence"/>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="vat_reg_no">VAT registration no</label>
            <input type="text" v-model="business.vat_reg_no" id="vat_reg_no" name="vat_reg_no" class="form-control form-control-sm" placeholder="Enter vat reg number"/>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="tin_no">TIN no.</label>
            <input type="text" v-model="business.tin_no" id="tin_no" name="tin_no" class="form-control form-control-sm" placeholder="Enter TIN Number"/>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="advance_deposit">Deposit</label>
            <input type="number" v-model="business.advance_deposit" v-validate="{ regex: /^[0-9]*(?:\.[0-9]{0,4})?$/ }" id="advance_deposit" name="advance_deposit" class="form-control form-control-sm" placeholder="Enter advance deposit"/>
            <div class="invalid-feedback">Please enter deposit number format</div>
          </div>
        </div>

        <div class="form-row mt-2">
<!--          <div class="col-md-6 col-sm-6 col-lg-4">-->
<!--            <label for="is_inc_pay">Is Inc Pay?</label>-->
<!--            <select v-model="business.is_inc_pay" id="is_inc_pay" name="is_inc_pay" class="form-control form-control-sm">-->
<!--              <option value="1" selected>Yes</option>-->
<!--              <option value="0">No</option>-->
<!--            </select>-->
<!--          </div>-->
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="remarks">Remarks</label>
            <input v-model="business.remarks" id="remarks" name="remarks" type="text" class="form-control form-control-sm"/>
          </div>
        </div>
        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Add Business</b-button>
            <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update Business</b-button>
            <b-button size="sm" variant="danger" class="form-control-sm" @click="$bvModal.hide('business-modal')">Cancel</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import http from "@state/http";

  export default {
    props: ["business","btn_edit"],

    components: { },
    data() {
      return {
        structures: [],
        validation_errors: {},
        show: false,
      };
    },
    mounted() {
      this.getCodes();
    },
    methods: {
      async save() {
        await this.$validator.validate().then(valid => {
          if (valid) {
             http.post("api/businesses", this.business)
                    .then(response => {
                      if (!response.data.error) {
                        this.$emit("resetForm");
                        this.$bvToast.toast(response.data.message, {
                          title: "Success",
                          autoHideDelay: 5000,
                          variant: "success"
                        });
                        this.$emit("getPersonBusiness");
                      }
                    })
                    .catch(error => {
                      this.validation_errors = error.response.data.errors;
                      this.show = true;
                      this.hide();
                    });
          }
        });
      },
      async update() {
        await this.$validator.validate().then(valid => {
          if (valid) {
            http.put("api/businesses/" + this.business.id, this.business)
                    .then(response => {
                      if (!response.data.error) {
                        this.$bvModal.hide("business-modal");
                        this.$bvToast.toast(response.data.message, {
                          title: "Success",
                          autoHideDelay: 5000,
                          variant: "success"
                        });
                        this.$emit("getPersonBusiness");
                      } else {
                        this.$bvToast.toast("Update Failed", {
                          title: "Error",
                          autoHideDelay: 5000,
                          variant: "danger"
                        });
                      }
                    })
                    .catch(error => {
                      this.validation_errors = error.response.data.errors;
                      this.show = true;
                      this.hide();
                      this.$bvToast.toast("Update Failed", {
                        title: "Error",
                        autoHideDelay: 5000,
                        variant: "danger"
                      });
                    });
          }
        });
      },
      getCodes() {
        let ses_id = this.$route.params.ses_id;
        http.get("api/business/codes/" + ses_id).then(response => {
          if (!response.error) {
            let data = response.data;
            this.structures = data.structures;
          }
        });
      },
      hide() {
        setTimeout(() => {
          this.show = false;
        }, 5000);
      },
    },
  };
</script>
<style>
  .c-required{
    color: red;
  }
</style>
